export default __webpack_public_path__ + "static/media/bbamDAI.53da43d9.png";